import { useTheme } from "@mui/material";

export const UseLabelTableStyles = (label: string, status?: any) => {
  const theme = useTheme();

  const getLabelColor = () => {
    switch (label.toLowerCase()) {
      case "status_campaign_data":
      case "manager_state_data":
      case "hr_state_data":
        switch (status.toLowerCase()) {
          case "completed":
            return theme.palette.status.completed;
          case "blocked":
            return theme.palette.status.blocked;
          case "in_progress":
            return theme.palette.status.in_progress;
          case "gap_completed":
            return theme.palette.status.gap_completed;
          case "canceled":
            return theme.palette.status.canceled;
          default:
            return theme.palette.text.primary;
        }
      case "status_detail_user":
        switch (status.toLowerCase()) {
          case "completed":
            return theme.palette.status.completed;
          case "not_completed":
            return theme.palette.status.blocked;
          default:
            return theme.palette.text.primary;
        }
      case "status_project_cost":
      case "status_project_cost_accounting":
        switch (status.toLowerCase()) {
          case "issued":
            return theme.palette.status.completed;
          case "draft":
            return theme.palette.status.gap_completed;
          case "requested":
            return theme.palette.status.in_progress;
          case "sent_to_sap":
            return theme.palette.status.blocked;
          default:
            return theme.palette.text.primary;
        }
      case "project_status":
        switch (status.toLowerCase()) {
          case "under_development":
            return theme.palette.status.gap_completed;
          case "pending_activation":
            return theme.palette.status.in_progress;
          case "active":
            return theme.palette.status.completed;
          case "closed":
            return theme.palette.status.canceled;
          default:
            return theme.palette.text.primary;
        }
      case "status_invitation":
        switch (status.toLowerCase()) {
          case "pending":
            return theme.palette.status.gap_completed;
          case "accepted":
            return theme.palette.status.completed;
          case "declined":
            return theme.palette.status.canceled;
          case "tentative":
            return theme.palette.status.in_progress;
          case "not_sent":
            return theme.palette.text.primary;
          default:
            return theme.palette.text.primary;
        }
      default:
        return theme.palette.text.primary;
    }
  };

  return {
    color: `${getLabelColor()}`,
  };
};
